/*
 * A team's card, entry or result names its people (decision 714; Kevin,
 * 2026-10-12), in two lines on all three views:
 *
 *   Una Radov, Ava Budman
 *   AFM-2 - with teammates: Luana Le, Yixin Li
 *
 * The tracked members first, because they are who the card is on screen for;
 * then the team, and the rest of its roster. The server sends the whole roster
 * with `tracked` marking the first group, and the words are the client's.
 */

import { list, type TeamMember } from "./api";
import { firstLast } from "./format";

export interface TeamNames {
  /** The members on the lists in view, as the first line names them. */
  tracked: string[];
  /** Everyone else on the roster: the second line's "with teammates". */
  teammates: string[];
}

/**
 * Splits a roster into the two lines' names, in roster order.
 *
 * Every name goes through firstLast, an unconfirmed member's included.
 */
export function teamNames(members: TeamMember[] | null | undefined): TeamNames {
  const tracked: string[] = [];
  const teammates: string[] = [];
  for (const m of list(members)) {
    (m.tracked ? tracked : teammates).push(firstLast(m.name));
  }
  return { tracked, teammates };
}

/** Whether a row is a team's, which is what decides the two-line rendering. */
export function isTeamRow(row: { team_id?: string | null | undefined }): boolean {
  return row.team_id != null;
}
